import React, { useContext } from "react";
import { AppContext } from "../App";
import { MdMenu } from "react-icons/md";
import { FiMapPin } from "react-icons/fi";
import logo from "../assets/logo.png";

export default function TopBar() {
  const appContext = useContext(AppContext);

  function goTo(item) {
    appContext.navTo({ item });
  }

  const navItems = [
    { label: "Home", key: "home" },
    { label: "About Us", key: "about_us" },
    { label: "Services", key: "services" },
    { label: "Contact Us", key: "contact_us" },
  ];

  return (
    <>
      <style>{`
        .topbar-modern-body {
          font-family: 'Libre Franklin', system-ui, sans-serif;
          background: rgba(10, 15, 24, 0.85);
          backdrop-filter: blur(16px);
          -webkit-backdrop-filter: blur(16px);
          border-bottom: 1px solid rgba(30, 45, 74, 0.6);
          transition: all 0.3s ease;
        }

        .tanzavibe-topbar__brand {
          background: none;
          border: none;
          padding: 0;
          cursor: pointer;
          display: flex;
          align-items: center;
          transition: opacity 0.3s ease;
        }

        .tanzavibe-topbar__brand:hover {
          opacity: 0.85;
        }

        .tanzavibe-topbar__brand img {
          object-fit: contain;
          height: 44px;
          width: auto;
        }

        .topbar-modern-link {
          background: none;
          border: none;
          color: #A0AEC0;
          font-size: 0.8rem;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          padding: 8px 16px;
          margin: 0 4px;
          cursor: pointer;
          position: relative;
          transition: color 0.3s ease;
        }

        .topbar-modern-link:hover {
          color: #ED8936;
        }

        .topbar-modern-link.active {
          color: #163314;
          font-weight: 600;
        }

        .topbar-modern-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0;
          height: 2px;
          background-color: #ED8936;
          transition: all 0.3s ease;
          transform: translateX(-50%);
        }

        .topbar-modern-link.active::after,
        .topbar-modern-link:hover::after {
          width: 24px;
        }

        .topbar-modern-menu-btn {
          background: none;
          border: 1px solid rgba(30, 45, 74, 0.8);
          border-radius: 4px;
          color: #ED8936;
          padding: 6px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .topbar-modern-menu-btn:hover {
          background: rgba(237, 137, 54, 0.1);
          border-color: #ED8936;
        }

        .topbar-registry-tag {
          font-size: 0.75rem;
          color: #718096;
          letter-spacing: 0.05em;
          border-left: 1px solid rgba(30, 45, 74, 0.8);
          padding-left: 16px;
        }

        .topbar-registry-tag strong {
          color: #38A169;
          font-weight: 600;
        }
      `}</style>

      <div className="TopBar topbar-modern">
        <div className="body topbar-modern-body">
          <div className="container d-flex align-items-center justify-content-between h-100">
            
            {/* Brand Logo Identity */}
            <button type="button" className="tanzavibe-topbar__brand" onClick={() => goTo("home")}>
              <img src={logo} width={75} />
            </button>

            {/* Desktop Navigation Menu (Hidden on mobile/tablet viewport layout grids) */}
            <div className="topbar-modern-nav-wrap d-none d-lg-flex align-items-center">
              <nav className="d-flex align-items-center">
                {navItems.map((item) => (
                  <button
                    key={item.key}
                    type="button"
                    className={`topbar-modern-link ${appContext.navItem === item.key ? "active" : ""}`}
                    onClick={() => goTo(item.key)}
                  >
                    {item.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Right Focal Area: Desktop Corporate Address Metadata (Replaces CTA block) */}
            <div className="d-none d-lg-flex align-items-center">
              <div className="topbar-registry-tag d-flex align-items-center gap-2">
                <FiMapPin size={14} style={{ color: '#38A169' }} />
                <strong>Arusha, TZ</strong>
              </div>
            </div>

            {/* Right Focal Area: Mobile/Tablet Burger Trigger Menu */}
            <div className="topbar-mobile-actions d-flex d-lg-none align-items-center">
              <button
                type="button"
                className="topbar-modern-menu-btn"
                onClick={appContext.openSideBar}
                aria-label="Open menu"
              >
                <MdMenu size={24} />
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}